import { Grid, Button, Input, Dimmer, Loader } from 'semantic-ui-react';
import { React, withRouter, connect, PT } from '@gasbuddy/react';
import { Auth, Nav, WexMatcherSingle, WexMatcherPotential } from '../../components';
import { Role, RoleAction } from '../../roles';
import { Action } from '../../reducers/actions';

class WexMatcherPage extends React.Component {
  state = {
    entryId: '0',
    customValue: '',
    loadNext: true,
    loading: true,
  }

  componentDidMount() {
    const { dispatch } = this.props;
    const { entryId } = this.state;
    dispatch({
      type: Action.Payment.WexMismatch.GetWexMismatch,
      meta: { apiAction: true },
      payload: {
        url: `/wexmismatch/${entryId}`,
      },
    });
  }

  componentWillReceiveProps(nextProps) {
    const { wexmismatches: { entryId, loading } } = this.props;
    const { entryId: nextEntryId, loading: nextLoading } = nextProps.wexmismatches;
    const { loadNext, entryId: stateEntryId } = this.state;
    if (loadNext && ((entryId !== nextEntryId) || loading !== nextLoading)) {
      this.setState({
        entryId: nextEntryId || entryId || stateEntryId,
        loadNext: false,
        loading: nextProps.wexmismatches.loading,
        customValue: '',
      });
    }
  }

  setCustomValue(e, data) {
    this.setState({ customValue: data.value });
  }

  restart() {
    const { dispatch } = this.props;
    this.setState({ loadNext: true, loading: true });
    dispatch({
      type: Action.Payment.WexMismatch.GetWexMismatch,
      meta: { apiAction: true },
      payload: {
        url: '/wexmismatch/0',
      },
    });
  }

  skip() {
    const { dispatch, wexmismatches: { entryId } } = this.props;
    this.setState({ loadNext: true, loading: true });
    dispatch({
      type: Action.Payment.WexMismatch.GetWexMismatch,
      meta: { apiAction: true },
      payload: {
        url: `/wexmismatch/${entryId}`,
      },
    });
  }

  saveCustomMatch(singlePoi) {
    const { customValue } = this.state;
    const { wexmismatches: { entryId } } = this.props;
    const stationId = singlePoi
      ? this.props?.wexmismatches?.stationDetails?.id
      : this.props?.wexmismatches?.stationDetails?.internal_name;
    const { dispatch } = this.props;
    this.setState({ loadNext: true, loading: true });
    dispatch({
      type: Action.Payment.WexMismatch.SaveWexMatch,
      meta: { apiAction: true },
      payload: {
        url: `/wexmismatch/${entryId}/save`,
        body: singlePoi ? { poiId: stationId, wexId: customValue } : { poiId: customValue, wexId: stationId },
      },
    });
  }

  saveMatch(poiId, wexId) {
    const { wexmismatches: { entryId } } = this.props;
    const { dispatch } = this.props;
    this.setState({ loadNext: true, loading: true });
    dispatch({
      type: Action.Payment.WexMismatch.SaveWexMatch,
      meta: { apiAction: true },
      payload: {
        url: `/wexmismatch/${entryId}/save`,
        body: { poiId, wexId },
      },
    });
  }

  render() {
    const { wexmismatches } = this.props;
    const { loading, customValue } = this.state;

    if (wexmismatches.errorMessage) {
      return (
        <Auth forRoles={[Role.AnyAdmin]}>
          <Nav>
            <Dimmer.Dimmable dimmed={loading}>
              <Dimmer active={loading}>
                <Loader />
              </Dimmer>
              <Grid centered relaxed divided="vertically">
                <Grid.Row>
                  <Grid.Column width={5} textAlign="center">
                    <div>
                      {wexmismatches.errorMessage}
                    </div>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column width={1} textAlign="center">
                    <div>
                      <Button
                        primary
                        onClick={() => this.skip()}
                        icon="forward"
                        labelPosition="left"
                        content="Skip"
                      />
                    </div>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Dimmer.Dimmable>
          </Nav>
        </Auth>
      );
    }

    if (wexmismatches.doneMismatches) {
      const { entryId: stateEntryId } = this.state;
      const empty = (stateEntryId === '0');
      return (
        <Auth
          forRoles={[Role.AnyAdmin]}
          forActions={[RoleAction.AdminPaymentLevelUsers]}
          hideUnauthorized
        >
          <Nav>
            <Dimmer.Dimmable dimmed={loading}>
              <Dimmer active={loading}>
                <Loader />
              </Dimmer>
              <Grid centered relaxed divided="vertically">
                <Grid.Row>
                  <Grid.Column width={3} textAlign="center">
                    <h2>
                      {empty
                        ? 'There are no mismatched stations'
                        : 'Reached the end of mismatched Stations'
                      }
                    </h2>
                  </Grid.Column>
                </Grid.Row>
                {!empty
                && (
                  <Grid.Row>
                    <Grid.Column width={3} textAlign="center">
                      <div>
                        <Button
                          primary
                          onClick={() => this.restart()}
                          icon="undo"
                          labelPosition="left"
                          content="Start Over"
                        />
                      </div>
                    </Grid.Column>
                  </Grid.Row>
                )
                }
              </Grid>
            </Dimmer.Dimmable>
          </Nav>
        </Auth>
      );
    }

    // If false, it's a single wex station with multiplePois
    const { singlePoi } = wexmismatches;
    const potentialStations = wexmismatches.potentialMatchesDetails || WexMatcherPage.defaultProps.wexmismatches.potentialMatchesDetails;
    let content = '';
    content = (
      <Auth forRoles={[Role.AnyAdmin]}>
        <Nav>
          <Dimmer.Dimmable dimmed={loading}>
            <Dimmer active={loading}>
              <Loader />
            </Dimmer>
            <Grid centered relaxed divided="vertically">
              {wexmismatches.stationDetails
                && (
                  <WexMatcherSingle stationDetails={wexmismatches.stationDetails} />
                )}
              <Grid.Row>
                {wexmismatches.stationDetails
                  && (
                    potentialStations.map(s => (
                      <WexMatcherPotential
                        singleStationDetails={wexmismatches.stationDetails}
                        stationDetails={s}
                        confirmFunc={
                          singlePoi
                            ? () => this.saveMatch(wexmismatches.stationDetails.id, s.internal_name)
                            : () => this.saveMatch(s.id, wexmismatches.stationDetails.internal_name)
                        }
                      />
                    ))
                  )
                }
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={4} textAlign="center">
                  <div>
                    <Input
                      control="Input"
                      value={customValue}
                      placeholder={`Enter ${singlePoi ? 'Wex' : 'Poi'} ID`}
                      onChange={(e, data) => this.setCustomValue(e, data)}
                    />
                    <Button
                      primary
                      onClick={() => this.saveCustomMatch(singlePoi)}
                      icon="check circle"
                      labelPosition="left"
                      content="Custom Match"
                    />
                  </div>
                </Grid.Column>
                <Grid.Column width={1} textAlign="center">
                  <div>
                    <Button
                      primary
                      onClick={() => this.skip()}
                      icon="forward"
                      labelPosition="left"
                      content="Skip"
                    />
                  </div>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Dimmer.Dimmable>
        </Nav>
      </Auth>
    );
    return content;
  }
}

WexMatcherPage.defaultProps = {
  wexmismatches: {
    loading: false,
    saved: false,
    error: false,
    singlePoi: false,
    doneMismatches: false,
    errorMessage: null,
    entryId: '0',
    stationDetails: null,
    potentialMatchesDetails: [],
  },
};

WexMatcherPage.propTypes = {
  dispatch: PT.func.isRequired,
  wexmismatches: PT.shape({
    loading: PT.bool,
    saved: PT.bool,
    doneMismatches: PT.bool,
    error: PT.bool,
    errorMessage: PT.string,
    entryId: PT.string,
    singlePoi: PT.string,
    stationDetails: PT.shape({
      brandings: PT.arrayOf(PT.shape({
        brand_id: PT.isnumber,
        branding_type: PT.string,
        image_url: PT.string,
      })),
    }),
    potentialMatchesDetails: PT.arrayOf(PT.shape({
      internal_name: PT.string,
    })),
  }),
};


const mapStateToProps = state => state;

export const WexMatcher = withRouter(connect(mapStateToProps)(WexMatcherPage));
